import {getHostConfigByHostname_UNSAFE} from '@aboutyou/config';

export const getKlarnaPostPurchaseSdkProxy = () => {
  return {
    target: 'https://x.klarnacdn.net',
    changeOrigin: true,
    pathRewrite: (_: string, req: {hostname: string}) => {
      // eslint-disable-next-line no-restricted-syntax
      const config = getHostConfigByHostname_UNSAFE(req.hostname);
      return config?.klarnaSdkUrl;
    },
  };
};
